module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/desenrola1x-fc694206a78517a1beca983e782bd511.png";